import React, { useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../../assests/leftArrow.svg";
import search from "../../../../assests/search.svg";
import filter from "../../../../assests/filterIcon.svg";
import eyeIcon from "../../../../assests/eyeIcon.svg";
import LoadingSpinner from "../../../Loading/component";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import "./VmCohort.css";

export const CohortListComponent = ({
  filterCohortData,
  loading,
  Search,
  stagecohortsTypes,
  activeCohortType,
  handleCohortTypeClick,
  loadMore, // ✅ new prop
  hasMore, // ✅ new prop
}) => {
  const navigate = useNavigate();
  const tableContainerRef = useRef(null);

  const sortDataDescending = (data, key) => {
    return [...data].sort((a, b) => (a[key] < b[key] ? 1 : -1));
  };

  const sortedData = sortDataDescending(filterCohortData, "id");

  const handleRowClick = (id) => {
    navigate(`/home/configuration/cohortdetails/${id}`);
  };

  const createNewCohortEntery = () => {
    navigate("/home/configuration/cohort/cohortcreation");
  };

  const arrowClick = () => {
    navigate("/");
  };

  // ✅ Scroll detection
  useEffect(() => {
    const handleScroll = () => {
      if (!tableContainerRef.current || !hasMore || loading) return;

      const { scrollTop, scrollHeight, clientHeight } =
        tableContainerRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 20) {
        loadMore(); // call parent
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [loading, hasMore]);

  return (
    <>
      <div className="vmcohort-main-div">
        <div>
          <Sidebar />
        </div>
        <div className="vmcohort-content-container">
          <div className="vmcohort-header">
            <img
              className="vmcohort-back-arrow"
              onClick={arrowClick}
              src={leftArrow}
              alt="Back"
            />
            <h2 className="vmcohort-heading">Vending Machine Cohort</h2>
          </div>

          <div className="vmcohort-search-container">
            <div className="vmcohort-search-input-container">
              <input
                type="search"
                className="vmcohort-search-input"
                placeholder="Search by Cohort Name / Cohort Id"
                onChange={(e) => Search(e.target.value)}
              />
              <img src={search} alt="Search" className="vmcohort-search-icon" />
            </div>

            <Button
              onClick={createNewCohortEntery}
              className="vmcohort-create-button"
              variant="primary"
              size="lg"
            >
              Create New Cohort
            </Button>
          </div>

          <div
            className="vmcohort-table-container"
            ref={tableContainerRef}
            style={{ maxHeight: "70vh", overflowY: "auto" }}
          >
            <Table striped>
              <thead>
                <tr style={{ border: "none" }}>
                  <th>Cohort ID</th>
                  <th>Cohort Name</th>
                  <th>Area Name</th>
                  <th>
                    <Dropdown className="vmcohort-filter-container">
                      <Dropdown.Toggle
                        variant="none"
                        className="vmcohort-filter-toggle"
                        id="dropdown-basic"
                      >
                        <img src={filter} alt="Filter" />
                        <span className="vmcohort-filter-label">
                          Cohort Type
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="vmcohort-dropdown-menu">
                        {stagecohortsTypes?.map((item) => (
                          <Dropdown.Item
                            key={item.id}
                            id={item.id}
                            active={activeCohortType === item.id}
                            onClick={() =>
                              handleCohortTypeClick(item.id, item.type)
                            }
                          >
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {filterCohortData?.length > 0 ? (
                  filterCohortData.map((el) => (
                    <tr
                      key={el.id}
                      className="vmcohort-table-row"
                      onClick={() => handleRowClick(el.id)}
                    >
                      <td style={{ textAlign: "left" }}>{el.id}</td>
                      <td style={{ textAlign: "left" }}>{el.name}</td>
                      <td style={{ textAlign: "left" }}>{el.area_name}</td>
                      <td style={{ textAlign: "left" }}>{el.type}</td>
                      <td>
                        <img
                          src={eyeIcon}
                          loading="lazy"
                          alt="View Details"
                          className="vmcohort-eye-icon"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No cohorts found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {/* ✅ Loader for scroll */}
            {loading && (
              <div style={{ textAlign: "center", padding: "10px" }}>
                <LoadingSpinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
